import { html, css, LitElement } from 'lit';

import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import { q1AppFooterStyles } from './q1-app-footer-styles.js';

export class Q1AppFooter extends LitElement {
  static styles = [ q1AppFooterStyles ];

  static properties = {
    variant: { type: String, reflect: true }, // default, white-text
    
    _afLink: { type: String, attribute: 'al' },
    _afLinkVisible: { type: Boolean }
  };

  constructor() {
    super();

    this.variant = 'default';
    
    this._afLink = null;
    this._afLinkVisible = false;
  }

  render() {
    return html`
      <footer-inner part="base">
        <sl-icon library="q1" name="q1-logo-text-r" class="logo"></sl-icon>
        <p>
          The q1 Network is a part of <a href="https://quorum.one" target="_blank">Quorum1</a>,
          a member-owned collective pioneering the future of work.
        </p>
        <ul id="footer-links">
          <li><a target="_blank"
            href="https://github.com/quorum1/governance/blob/main/docs/privacy-policy.md"
          >Privacy</a></li>

          <li><a target="_blank"
            href="https://github.com/quorum1/governance/blob/main/docs/terms-of-service.md"
          >Terms</a></li>

          <li><a target="_blank"
            href="https://github.com/quorum1/governance"
          >Governance</a></li>
        </ul>
        
        <ul id="social-links">
          <li><a target="_blank"
            href="https://linkedin.com/company/quorum1"
          ><sl-icon library="tabler" name="brand-linkedin"></sl-icon></a></li>
          
          <li><a target="_blank"
            href="https://www.youtube.com/@quorum_1"
          ><sl-icon library="tabler" name="brand-youtube"></sl-icon></a></li>
          
          <li><a target="_blank"
            href="https://lu.ma/q1-network"
          ><sl-icon library="material" name="calendar_month"></sl-icon></a></li>
          
          <li><a target="_blank"
            href="https://github.com/quorum1"
          ><sl-icon library="tabler" name="brand-github"></sl-icon></a></li>
          
          <li><a target="_blank"
            href="https://open.spotify.com/show/6hIYwyBBCDmzOMob1sKInu"
          ><sl-icon library="tabler" name="brand-spotify"></sl-icon></a></li>
          
          <li><a target="_blank"
            href="https://podcasts.apple.com/us/podcast/quorum1-future-of-work-talks/id1755046941"
          ><sl-icon library="tabler" name="brand-apple-podcast"></sl-icon></a></li>
        </ul>

        ${this.afLinkTemplate}
      </footer-inner>
    `;
  }

  showAfLink() {
    this._afLink = document.q1_afLink;
    this._afLinkVisible = true;
    console.log('Link Shown:', this._afLink);
  }

  setupAfLink(link) {
    document.q1_afLink = link;
    document.q1_appFooterElement = this;
    
    const isFirstSetup = !document.q1_afLinkIsSetup;
    if (isFirstSetup) {
      document.q1_afLinkIsSetup = true;

      let ctrlPresses = [];
      const timeLimit = 1000;

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Control') {
          ctrlPresses.push(Date.now());
          if (ctrlPresses.length > 3) ctrlPresses.shift();

          if (ctrlPresses.length === 3 && (ctrlPresses[2] - ctrlPresses[0] <= timeLimit)) {
            ctrlPresses = [];
            document.q1_appFooterElement.showAfLink();
          }
        }
      });
    }
  }

  get afLinkTemplate() {
    return !this._afLinkVisible ? null : html`
      <a id="af-link" target="_blank" href=${this._afLink}>π</a>
    `;
  }
}

customElements.define('q1-app-footer', Q1AppFooter);
